import { gql } from "@apollo/client";
import moment from "moment";

export const GET_PROFESIONALES_BY_VISITA = gql`
query evaluacionProfesional($idEvaluacion: Int!) {
    evaluacionProfesional(idEvaluacion: $idEvaluacion){
      idEvaluacionProfesional
      fechaDesde
      fechaHasta      
      idTipoProfesional
      idTipoProfesionalNavigation {
        descripcion
      }
      idProfesional
      idProfesionalNavigation {
        nombre
        apellido
      }
      idFiguraProfesionalNavigation {
        descripcion
      }
      idFrecuenciaRequeridaNavigation {
        idFrecuenciaProfesional
        frecuencia
        cantDiasHoras
      }
    }
}`;

export const parseProfesionalesByVisita = (data) => {
  if (!data || !data.evaluacionProfesional) return [];

  return data.evaluacionProfesional.map((prof) => ({
    id: prof.idEvaluacionProfesional,
    fechaAsignacionDesde: moment(prof.fechaDesde).format('DD/MM/YYYY'),
    fechaAsignacionHasta: moment(prof.fechaHasta).format('DD/MM/YYYY'),
    idProfesional: prof.idProfesional,
    idTipoProfesional: prof.idTipoProfesional,
    tipoProfesional: prof.idTipoProfesionalNavigation?.descripcion,
    nombre: prof.idProfesionalNavigation?.nombre,
    apellido: prof.idProfesionalNavigation?.apellido,
    rol: prof.idFiguraProfesionalNavigation?.descripcion,
    idFrecuencia: prof.idFrecuenciaRequeridaNavigation?.idFrecuenciaProfesional,
    frecuencia: prof.idFrecuenciaRequeridaNavigation?.frecuencia,
    cantDiasHoras: prof.idFrecuenciaRequeridaNavigation?.cantDiasHoras
  }));
};